import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=02bfb7d2&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./uploadFile.vue?vue&type=style&index=0&id=02bfb7d2&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./uploadFile.vue?vue&type=style&index=1&id=02bfb7d2&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "02bfb7d2",
  "a4e8c46e"
  
)

export default component.exports